(function () {
    'use strict';

    angular.module('app.stockItems', [
        // Angular modules 
        'ngRoute',
        'ngFileUpload'

        // Custom modules 

        // 3rd Party Modules

    ]);
})();